import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RecoverForm } from "../../../components/Admin/Auth";
import { useLanguage } from "../../../contexts";
import { EcosystemPanel } from "../Auth/EcosystemPanel";
import { BrujulaPanel } from "../Auth/BrujulaPanel";
import { EcosystemMobileHeader } from "../Auth/EcosystemMobileHeader";
import { LanguageSwitcher } from "../Auth/LanguageSwitcher";
import { SocialLinks } from "../Auth/SocialLinks";
import logoInk from "../../../assets/png/brand/logo-ink.png";
import "./Recover.scss";

export function Recover() {
  const navigate = useNavigate();
  const [rightVariant] = useState(() => (Math.random() < 0.5 ? "ecosystem" : "brujula"));
  const { changeLanguage, translations } = useLanguage();
  const t = (key) => translations[key] || key;

  useEffect(() => {
    if (!localStorage.getItem("appLanguage")) {
      const idiomaNavegador = navigator.language || navigator.userLanguage;
      const idioma = idiomaNavegador.split("-")[0];
      changeLanguage(["es", "en", "pt", "fr"].includes(idioma) ? idioma : "es");
    }
  }, []);

  return (
    <div className="login-page">
      <EcosystemMobileHeader t={t} />

      <div className="login-page__form-panel">
        <img src={logoInk} alt="sustemia" className="login-page__logo" />

        <div className="login-page__center">
          <span className="login-page__kicker">{t("login_kicker")}</span>

          <div className="login-page__form-wrap">
            <RecoverForm />
            <div className="login-page__register">
              <a
                href="#login"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/admin");
                }}
              >
                {t("back")}
              </a>
            </div>
          </div>
        </div>

        <div className="login-page__footer">
          <span className="login-page__footer-tag">{t("login_footer_tag")}</span>
          <SocialLinks />
          <LanguageSwitcher />
        </div>
      </div>

      <div className="login-page__eco-panel">
        {rightVariant === "ecosystem" ? <EcosystemPanel t={t} /> : <BrujulaPanel t={t} />}
      </div>
    </div>
  );
}
